import styled from "styled-components";

export const Container = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`;

export const Title = styled.span`
  line-height: 15px;
  text-align: center;
`;
